<div class="flex row between hostel_details_top" [ngClass]="{'no-margin': !hostel?.minRate}">
  <ng-container *ngIf="isServer; else lazyBrowserHostelNameTpl">
    <h1 class="hostel-name" [ngClass]="{'no-availability': !hostel?.minRate}">
      [[SSR_DATA_HOSTEL_NAME]]
    </h1>
  </ng-container>

  <ng-template #lazyBrowserHostelNameTpl>
    <h1 class="skeleton skeleton-header skeleton-name hostel-name" [ngClass]="{'no-availability': !hostel?.minRate}">
      <ng-container *ngIf="hostel">
        {{hostel.name}}
      </ng-container>
    </h1>
  </ng-template>

 <!-- Conditionally display the availability message or price -->
 <div class="flex row base-price">
  <div *ngIf="hostel" >
    <!-- if not minrate and no hyperguestPropertyId then show nothing -->
    <ng-container *ngIf="hostel?.minRate || hostel?.hyperguestPropertyId; else noAvailabilityTpl">
      <!-- if minrate then show minrate -->
      <ng-container *ngIf="hostel?.minRate">
        <ng-container i18n class="text light starting_from">
          Starting from
        </ng-container>
      <h2 class="skeleton skeleton-header skeleton-price">
        <ng-container *ngIf="(currency | async) as c">
          {{ hostel?.minRate | currency: c.code }}
        </ng-container>
        </h2>
      </ng-container>
    </ng-container>
  </div>
</div>
</div>

<!-- Template for no availability -->
<ng-template #noAvailabilityTpl>
<div class="no-availability-bubble">
  <div class="icon">
    <svg-icon [svgStyle]="{'width.px': 21, 'height.px': 22}" src="/assets/icons/info.svg"></svg-icon>
  </div>
  <ng-container i18n>This property has no availability on these dates</ng-container>
</div>
</ng-template>

<div class="flex row between hostel_details_bottom">
  <div class="flex-column left">
    <div class="flex row stats">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Star 1" d="M6.88124 1.14628C7.23338 0.0625065 8.76662 0.0625076 9.11876 1.14628L10.2009 4.47666C10.3584 4.96134 10.81 5.28949 11.3196 5.28949H14.8214C15.961 5.28949 16.4348 6.7477 15.5128 7.41751L12.6798 9.4758C12.2676 9.77535 12.095 10.3063 12.2525 10.791L13.3346 14.1214C13.6868 15.2051 12.4463 16.1064 11.5244 15.4366L8.69143 13.3783C8.27914 13.0787 7.72086 13.0787 7.30857 13.3783L4.47557 15.4366C3.55366 16.1064 2.31324 15.2051 2.66537 14.1214L3.74748 10.791C3.90496 10.3063 3.73244 9.77535 3.32015 9.4758L0.487159 7.41751C-0.434754 6.7477 0.0390475 5.28949 1.17859 5.28949H4.68036C5.18998 5.28949 5.64165 4.96134 5.79913 4.47666L6.88124 1.14628Z" fill="#2E2E51"/>
      </svg>
      <ng-container *ngIf="hostel">
        <!-- <svg-icon style="height: 20px" [svgStyle]="{'width.px': 20, 'height.px': 20, 'fill': 'black'}" src="/assets/icons/star_fill.svg"></svg-icon> -->
        <div class="text strong dot_after">
          <span *ngIf="hostel">
            {{combinedRating | number: '1.0-2'}}
          </span>
          <span *ngIf="!hostel" class="skeleton skeleton-normal skeleton-rating"></span>
        </div>
        <div>&bull;</div>
        <div class="text light dot_after">
          <span *ngIf="hostel">
            {{combinedReviewCount}}
          </span>
          <ng-container *ngIf="!hostel" class="skeleton skeleton-normal skeleton-reviews"></ng-container>
          <ng-container i18n>
            &nbsp;reviews
          </ng-container>
        </div>
        <div>&bull;</div>
        <div class="text light">
          <ng-container *ngIf="hostel">
            {{hostel.propertyRecommendationCount ?? 0}}
          </ng-container>
          <ng-container *ngIf="!hostel" class="skeleton skeleton-normal skeleton-recommendations"></ng-container>
          <ng-container i18n>
            &nbsp;recommendations
          </ng-container>
        </div>
      </ng-container>
      <span *ngIf="!hostel" class="skeleton skeleton-normal skeleton-stats"></span>
    </div>

    <div class="flex row address">
      <span style="height: 20px; width: 20px">
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 87">
          <path id="Vector" d="M14.5 7.54545C14.5 12.6364 8 17 8 17C8 17 1.5 12.6364 1.5 7.54545C1.5 5.80949 2.18482 4.14463 3.40381 2.91712C4.62279 1.68961 6.27609 1 8 1C9.72391 1 11.3772 1.68961 12.5962 2.91712C13.8152 4.14463 14.5 5.80949 14.5 7.54545Z" stroke="#2E2E51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path id="Vector_2" d="M7.99967 9.72722C9.19629 9.72722 10.1663 8.75039 10.1663 7.5454C10.1663 6.34042 9.19629 5.36359 7.99967 5.36359C6.80306 5.36359 5.83301 6.34042 5.83301 7.5454C5.83301 8.75039 6.80306 9.72722 7.99967 9.72722Z" stroke="#2E2E51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
      </span>
      <div class="text strong dot_after">
        <ng-container *ngIf="isServer; else lazyBrowserHostelAddressTpl">
          <span>
            [[SSR_DATA_HOSTEL_LOCATION]]
          </span>
        </ng-container>
        <ng-template #lazyBrowserHostelAddressTpl>
          <span *ngIf="hostel">
            {{hostel.address.city}},&nbsp;{{hostel.address.country}}
          </span>
        </ng-template>
        <span *ngIf="!hostel" class="skeleton skeleton-normal skeleton-address"></span>
      </div>
      <div>&bull;</div>
      <div class="text small link" (click)="goToAnchor('map'); openInGoogleMaps()">
        <ng-container i18n>View On Map</ng-container>
      </div>

    </div>
  </div>


  <div class="flex row right" *ngIf="hostel?.minRate">
    <!-- Other button elements if any -->
<!--      <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/heart_outline.svg"></svg-icon>-->
<!--      <span>Save</span>-->
<!--    </button>-->
    <!-- <button [@fadeIn] class="btn btn-raised-icon white" (click)="copyCurrentURL();">
      <span style="height: 18px; width: 18px">
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Group 944">
          <path id="Vector" d="M1.16602 8V13.6C1.16602 13.9713 1.31966 14.3274 1.59315 14.5899C1.86664 14.8525 2.23757 15 2.62435 15H11.3743C11.7611 15 12.1321 14.8525 12.4055 14.5899C12.679 14.3274 12.8327 13.9713 12.8327 13.6V8" stroke="#2E2E51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path id="Vector_2" d="M9.91536 3.8L6.9987 1L4.08203 3.8" stroke="#2E2E51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path id="Vector_3" d="M7 1V10.1" stroke="#2E2E51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
      </span>
      <span>Share</span>
    </button> -->
    
    <button [@fadeIn] class="btn btn-raised theme" (click)="goToAnchor('availability')">
      <ng-container i18n>Select Rooms</ng-container>
    </button>
  </div>
</div>
